import type ScheduleBoardEmployee from 'ab-viewModels/scheduleBoardEmployee.viewModel';

import * as TextUtil from '@acceligentllc/shared/utils/text';

export const getDisplayData = (employee: ScheduleBoardEmployee) => {
	const { firstName: _firstName, lastName, duplicateDisplayNameExists } = employee;
	return {
		firstName: TextUtil.capitalizeText(_firstName && (duplicateDisplayNameExists ? _firstName.slice(0, 2) : _firstName[0])),
		lastName: TextUtil.capitalizeText(lastName),
	};
};
